module.exports = __webpack_public_path__ + "img/yonghu.a2f85c03.svg";